<div class="float-end">
  <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.cancel" [disabled]="changesMade == false || this.saving" (click)="clear(false);">Cancel</button>
  <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.save" [disabled]="changesMade == false || this.saving" (click)="saveChanges();">Save</button>
</div>

<div class="grid-scratch-pad flex-column flex-fill" (dragover)="onDragOver($event)" (drop)="onDropScopingItem($event, dragDropComponentType.ScopingItem, null)">
  <div [class.card-columns]="layout==='card'" [style.column-count]="columnCount" [class.row]="layout !=='card'" class="row"
    style="width: 100%;background-color:gainsboro; margin:-1px 0 0 0!important;min-height:100%;padding-top:10px">
    @for (group of groups; track group) {
    <div [class.col-sm-6]="layout !=='card'" [class.card]="layout ==='card'">
      <app-drag-drop-scoping-item [group]="group">
      </app-drag-drop-scoping-item>
    </div>
    }
  </div>
</div>